var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classWell},[_c('p',[(_vm.showIcon)?_c('i',{class:_vm.classIcon}):_vm._e(),_vm._t("default",[_vm._v(_vm._s(_vm.note))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }